function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

import React from 'react';
import utils from '../../../common/utils';
import { isSiteMode, isSEOMode } from '../../../common/window/viewModeWrapper';
import EVENTS from '../../../common/constants/events';
import { GalleryComponent } from '../../galleryComponent';

var LoveButton =
/*#__PURE__*/
function (_GalleryComponent) {
  _inheritsLoose(LoveButton, _GalleryComponent);

  function LoveButton(props) {
    var _this;

    _this = _GalleryComponent.call(this, props) || this;
    _this.toggleLove = _this.toggleLove.bind(_assertThisInitialized(_this));
    _this.onKeyPress = _this.onKeyPress.bind(_assertThisInitialized(_this));
    _this.state = {
      animate: false
    };
    return _this;
  }

  var _proto = LoveButton.prototype;

  _proto.onKeyPress = function onKeyPress(e) {
    switch (e.keyCode || e.charCode) {
      case 32: //space

      case 13:
        //enter
        e.preventDefault();
        e.stopPropagation();
        this.toggleLove(e);
        return false;
    }
  };

  _proto.toggleLove = function toggleLove(e) {
    e.stopPropagation();
    e.preventDefault();
    this.props.actions.eventsListener(EVENTS.LOVE_BUTTON_CLICKED, this.props);
    this.setState({
      animate: !this.props.isLoved
    });
  };

  _proto.containerClassName = function containerClassName() {
    switch (this.props.layout) {
      case 'fullscreen':
        return 'fullscreen-social-love-container show-tooltip';

      default:
        return 'block-fullscreen gallery-item-social-love gallery-item-social-button show-tooltip';
    }
  };

  _proto.buttonClasssName = function buttonClasssName() {
    var className = [];

    switch (this.props.layout) {
      case 'fullscreen':
        className.push('fullscreen-social-love');
        break;

      default:
        className.push('gallery-item-social-love');

        if (!this.props.styleParams.isStoreGallery) {
          className.push('block-fullscreen');
        }

    }

    className.push(this.viewClassName());

    if (this.props.isLoved) {
      className.push('progallery-svg-font-icons-love_full pro-gallery-loved');
    } else {
      className.push('progallery-svg-font-icons-love_empty');
    }

    if (this.state.animate) {
      className.push('love-animation');
    }

    return className.join(' ');
  };

  _proto.viewClassName = function viewClassName() {
    switch (this.props.layout) {
      case 'fullscreen':
        return this.props.device === 'desktop' ? 'fullscreen-icon' : '';

      default:
        return '';
    }
  };

  _proto.counterClassName = function counterClassName() {
    switch (this.props.layout) {
      case 'fullscreen':
        return 'fullscreen-social-love-count pro-fullscreen-shown ' + this.viewClassName();

      default:
        return 'block-fullscreen gallery-item-social-love-count ' + this.viewClassName();
    }
  };

  _proto.createLoveCounter = function createLoveCounter() {
    var count = this.props.loveCount || 0;
    return !!this.props.showCounter && count > 0 ? React.createElement("i", {
      "data-hook": "love-counter",
      className: this.counterClassName()
    }, count) : null;
  };

  _proto.render = function render() {
    var loveCounter = this.createLoveCounter();
    var clickAction = isSiteMode() || isSEOMode() ? utils.getMobileEnabledClick(this.toggleLove) : {
      onClick: function onClick(e) {
        return e.stopPropagation();
      }
    };
    var loveColor = this.props.isLoved ? {
      color: 'red'
    } : {};
    return React.createElement("span", _extends({
      "data-hook": "love-button",
      className: this.containerClassName()
    }, clickAction, {
      onKeyDown: this.onKeyPress,
      tabIndex: this.props.styleParams.isSlideshow && this.props.currentIdx === this.props.idx ? 0 : -1
    }), React.createElement("button", {
      "data-hook": "love-icon",
      className: this.buttonClasssName(),
      role: "checkbox",
      "aria-checked": this.props.isLoved,
      style: loveColor,
      tabIndex: -1
    }), loveCounter);
  };

  return LoveButton;
}(GalleryComponent);

export default LoveButton;